import { createSelector } from "reselect";
import { selectAccountState } from "../accountSelectors";
export const selectCreditsState = createSelector(selectAccountState, account => account.credits);
export const selectCredits = createSelector(selectCreditsState, credit => credit.list);
